import React, { memo } from "react";
import { css } from "@emotion/core";
import { connect } from "react-redux";
import WithStyles from "shared/components/WithStyles";
import { isLoggedIn as _isLoggedIn } from "shared/store/app/selectors";

import LoggedIn from "../LoggedIn";
import NotLoggedIn from "../NotLoggedIn";

const subCss = css`
    width: 212px;
    min-height: 158px;
    background: #fff;
    padding: 20px;
`;

interface ISubMenuProps {
    isLoggedIn: boolean;
}

function SubMenu({ isLoggedIn }: ISubMenuProps) {
    return <WithStyles cssProps={subCss}>{isLoggedIn ? <LoggedIn /> : <NotLoggedIn />}</WithStyles>;
}

const mapStateToProps = (state: any) => ({
    isLoggedIn: _isLoggedIn(state),
});

export default connect(mapStateToProps)(memo(SubMenu));
